import { render, staticRenderFns } from "./CreditNotesDialog.vue?vue&type=template&id=8fdde20e"
import script from "./CreditNotesDialog.vue?vue&type=script&lang=js"
export * from "./CreditNotesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports